import i18next from 'i18next';
import { openDialog } from '../base/dialog/actions';
import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { hideNotification, NOTIFICATION_TIMEOUT_TYPE, showErrorNotification, showNotification, showWarningNotification } from '../notifications';
import DialogRoomCascade from './components/web/DialogRoomCascade';
import { CR_NOTIFICATIONS } from './constants';
import { updateCascadeParticipant, updateRoomCascadeSession } from './slice';
// import i18n from "i18next";
/**
 * Registers a change handler for state['features/base/conference'].conference to
 * set the event listeners needed for the A/V moderation feature to operate.
 */
StateListenerRegistry.register((state) => state["features/base/conference"].conference, (conference, { getState, dispatch }, previousConference) => {
    if (conference && !previousConference) {
        conference.on(JitsiConferenceEvents.ROOM_CASCADE_SESSION_STATE_CHANGED, ({ id, status, statusType, statusMessage, roomId, sessionId }) => {
            dispatch(hideNotification(CR_NOTIFICATIONS.START_CASCADE_ID));
            if (status === "error") {
                dispatch(showErrorNotification({
                    titleKey: `roomCascade.notification.error.title`,
                    description: i18next.t(`roomCascade.notification.error.${statusType}`),
                    // disableClosing: true
                }, NOTIFICATION_TIMEOUT_TYPE.LONG));
            }
            else if (status === "warning") {
                dispatch(showWarningNotification({
                    titleKey: `roomCascade.notification.warning.${statusType}`,
                    description: i18next.t(`roomCascade.notification.warning.${statusType}-content`),
                    // disableClosing: true
                }, NOTIFICATION_TIMEOUT_TYPE.LONG));
            }
            else if (status === "info") {
                if (statusType === "dst-room-pass-not-match") {
                    dispatch(showNotification({
                        uid: CR_NOTIFICATIONS.CASCADE_WRONG_PASS_ID,
                        titleKey: `roomCascade.notification.info.${statusType}`,
                        description: i18next.t(`roomCascade.notification.info.${statusType}-content`),
                        disableClosing: false,
                        customActionNameKey: ['notify.action.close', 'roomCascade.notification.info.retype'],
                        customActionHandler: [() => dispatch(hideNotification(CR_NOTIFICATIONS.CASCADE_WRONG_PASS_ID)), () => dispatch(openDialog(DialogRoomCascade, { keepData: true }))],
                    }, NOTIFICATION_TIMEOUT_TYPE.LONG));
                }
            }
            else if (status === "on") {
                setTimeout(() => {
                    dispatch(updateCascadeParticipant(roomId));
                }, 3000);
            }
            else {
                dispatch(showNotification({
                    titleKey: `roomCascade.notification.${status}.title`,
                    description: i18next.t(`roomCascade.notification.${status}.content`, { roomId }),
                    // disableClosing: true
                }, NOTIFICATION_TIMEOUT_TYPE.LONG));
            }
            dispatch(updateRoomCascadeSession({
                roomId,
                state: status
            }));
        });
    }
});
